<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- E300系共通部品_Steps -->
    <app-e300-steps></app-e300-steps>

    <!-- タイトル -->
    <div class="title">
      <h1>
        <label>問い合わせの登録</label>
      </h1>
    </div>

    <!-- 備考 -->
    <div class="note">
      <label>
        以下の項目に必要事項をご記載後、「確認画面へ進む」ボタンをクリックしてください。<br />
        <!-- <label class="warning">
          ※【必須】の項目は入力必須項目です。必ずご記載ください。
        </label> -->
      </label>
    </div>

    <!-- 問い合わせ登録(E301) -->
    <div *ngIf="!confirmationFlag">
      <!-- 問い合わせ区分エリア -->
      <div class="inquiry-area">
        <!-- 問い合わせ区分 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- 問い合わせ区分 -->
            <tr>
              <td class="item-name">問い合わせ区分</td>
              <td class="item-information">
                <p-dropdown
                  [options]="getDicList(7)"
                  [(ngModel)]="inquiryKbn"
                  optionLabel="sp_name"
                  optionValue="sp_code"
                  styleClass="information-Form-dropdown"
                  (onChange)="changeInquiryKbn()"
                ></p-dropdown>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <!-- 問い合わせ区分が"退会の申請"以外 -->
      <div *ngIf="3 != inquiryKbn" [formGroup]="e301InquiryInputForm">
        <!-- サブタイトル -->
        <div class="sub-title">
          <h2>問い合わせ内容</h2>
        </div>
        <div class="inquiry-textarea">
          <textarea pInputTextarea formControlName="inquiry"></textarea>
          <!-- エラーメッセージ出力箇所 -->
          <app-validator-message
            [control]="e301InquiryInputForm.get('inquiry')"
          >
          </app-validator-message>
        </div>

        <!-- ヴァリデーションチェックメッセージエリア -->
        <div class="p-d-flex p-jc-center error-area" *ngIf="!e301InquiryInputForm.valid">
          <label class="warning platform-warning-text">
            未入力の項目、またはエラーがあります。
          </label>
        </div>
        <!-- 余白エリア -->
        <div class="p-d-flex p-jc-center error-area" *ngIf="e301InquiryInputForm.valid">
          <label class="warning platform-warning-text">
            &nbsp;
          </label>
        </div>


        <!-- ボタンエリア -->
        <div class="p-d-flex p-jc-center button-area">
          <button
            pButton
            type="button"
            label="確認画面へ進む"
            class="button-default-size button1"
            (click)="moveE302()"
            [disabled]="!e301InquiryInputForm.valid"
          ></button>
        </div>
      </div>

      <!-- 問い合わせ区分が"退会の申請"の場合 -->
      <div *ngIf="3 == inquiryKbn">
        <!-- 退会注意文言 -->
        <div class="withdrawal-note">
          <div class="warning">ご退会にあたり、下記にご注意ください。</div>
          <div class="note">
            <ul>
              <li type="disc">
                会員プロフィールおよび課題・ソリューション、並びに主催した分科会情報もプラットフォームより削除されます。
              </li>
              <li type="disc">
                分科会主催者様は、各自保有する分科会メンバーの情報を適正に処分してください。（分科会主催者様が各自保有する分科会メンバーの情報管理について、内閣府及び当プラットフォームは責任を負いません。）
              </li>
              <li type="disc">
                退会処理に時間を要するため、退会後一定期間会員検索に情報が残ってしまうことをご了承ください。
              </li>
              <li type="disc">
                <a
                  href="./data/s12_takiaitodoke.docx"
                  target="_blank"
                  >退会届 <i class="pi pi-clone"></i> </a
                >をダウンロードし、必要事項記載の上、下記運営事務局へご提出ください。
              </li>
            </ul>
          </div>
        </div>

        <!-- 退会宛先 -->
        <div class="withdrawal-address">
          <labal class="withdrawal-address-title">
            <!-- 地方創生SDGs官民連携プラットフォーム 運営事務局（TOPPAN株式会社 内） -->
            地方創生SDGs官民連携プラットフォーム
          </labal>
          <br />
          <labal>
            <!-- 電話番号：03-6633-2772（対応時間：平日 10時～17時　※12時～13時除く） -->
            運営事務局の電話番号・メールアドレスは、4月中に掲載します。
          </labal>
          <br />
          <!-- <label>
            メールアドレス：
            <a href="mailto:info@mail.future-city.go.jp">
              info@mail.future-city.go.jp
            </a>
          </label> -->
        </div>
      </div>
    </div>

    <!------------------------------------------------------------------------->

    <!-- 問い合わせ登録確認(E302) -->
    <div *ngIf="confirmationFlag">
      <!-- 問い合わせ区分エリア -->
      <div class="inquiry-area">
        <!-- 問い合わせ区分 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- 問い合わせ区分 -->
            <tr>
              <td class="item-name">問い合わせ区分</td>
              <td class="item-information">
                {{ getDicName(7, inquiryKbn) }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <!-- 問い合わせ区分が"退会の申請"以外 -->
      <div>
        <!-- サブタイトル -->
        <div class="sub-title">
          <h2>問い合わせ内容</h2>
        </div>
        <div class="confirmation-inquiry-textarea">
          {{ e301InquiryInputForm.value.inquiry }}
        </div>
        <!-- 余白エリア -->
        <div class="p-d-flex p-jc-center error-area">
          <label class="warning platform-warning-text">
            &nbsp;
          </label>
        </div>

        <!-- ボタンエリア -->
        <div class="p-d-flex p-jc-center button-area">
          <button
            pButton
            type="button"
            label="登録する"
            class="button-default-size button1"
            (click)="moveE303()"
          ></button>
          <button
            pButton
            type="button"
            label="修正する"
            class="button-default-size button2"
            (click)="moveE301()"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
